'use strict'

const removeHash = value => value && value.replace('#', '')

const isPresetRefArray = (refArray, variantsData) => refArray.values.some(value => {
    const isVariantRelation = value.type === 'VariantRelation'
    if (!isVariantRelation || !value.variants.length) {
        return false
    }
    const presetCondition = variantsData[removeHash(value.variants[0])]
    return presetCondition && presetCondition.type === 'Preset'
})


const updateRefArrayAndVariantRelations = (resolvedRefArray, dataQuery, presets, mapName, shouldUpdateRefArrayAndVariantRelations) => {
    if (!shouldUpdateRefArrayAndVariantRelations || !presets.length) {
        return {
            [dataQuery]: {
                ...resolvedRefArray,
                id: dataQuery,
                values: resolvedRefArray.values.map(x => `#${x.id}`)
            }
        }
    }
    const refArrayAndVariantRelations = {}
    const presetItemKey = mapName === 'layout_data' ? 'layout' : 'style'

    const getItemIdUnderPresetCondition = presetCondition => {
        const getDefaultItemId = () => resolvedRefArray.values.find(value => value.type !== 'VariantRelation').id // there should always be a default value

        const variantRelationWithPresetCondition = resolvedRefArray.values
            .find(value => value.type === 'VariantRelation' && value.variants
                .some(variantId => removeHash(variantId) === presetCondition))
        return variantRelationWithPresetCondition ? variantRelationWithPresetCondition.to : getDefaultItemId()
    }

    const newRefArrayValues = presets.map(presetDataItem => {
        if (presetDataItem.type === 'PresetData') {
            return getItemIdUnderPresetCondition(presetDataItem[presetItemKey])
        }

        const presetItem = presetDataItem.to
        const itemId = getItemIdUnderPresetCondition(presetItem[presetItemKey])

        const variantRelationId = `${dataQuery}-${presetDataItem.id}`
        refArrayAndVariantRelations[variantRelationId] = {
            ...presetDataItem,
            id: variantRelationId,
            to: itemId
        }

        return variantRelationId
    })

    refArrayAndVariantRelations[dataQuery] = {
        ...resolvedRefArray,
        id: dataQuery,
        values: newRefArrayValues
    }

    return refArrayAndVariantRelations
}

module.exports = {
    functionLibrary: {
        updateRefArrayAndVariantRelations,
        isPresetRefArray
    }
}
